<template>
    <ion-toolbar>
        <ion-title>Rate your experience</ion-title>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
        <div class="user_avatar page_padding_top text-center">
            <el-avatar :size="'medium'" :shape=" userRole == 'locum' ? 'square' : 'circle' " :src="userRole == 'locum' ? shift.pharmacy.image : shift.locum.image" v-if="userRole == 'locum' ? shift.pharmacy.image : shift.locum.image" />
            <el-avatar :size="'medium'" :shape=" userRole == 'locum' ? 'square' : 'circle' " icon="el-icon-user-solid" v-else></el-avatar>
        </div>
        <div class="page_rating_text">How was your experience working with <span>{{ userRole == 'locum' ? shift.pharmacy.name : shift.locum.name }}?</span></div>
        <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules" :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="submit('userForm')">
            <el-form-item class="rating_form_item" label="Give a star rating" prop="rating" v-if="userRole == 'locum'">
                <el-rate :ref='el => formsData.userForm.rating.ref = el' v-model="formsData.userForm.rating.value" @change="checkFormValidation('userForm', true, 'rating')"></el-rate>
            </el-form-item>
            <template v-else>
                <el-form-item class="rating_form_item" label="Communication" prop="communication">
                    <el-rate :ref='el => formsData.userForm.communication.ref = el' v-model="formsData.userForm.communication.value" @change="checkFormValidation('userForm', true, 'communication')"></el-rate>
                </el-form-item>
                <el-form-item class="rating_form_item" label="Interpersonal Skills" prop="interpersonalSkills">
                    <el-rate :ref='el => formsData.userForm.interpersonalSkills.ref = el' v-model="formsData.userForm.interpersonalSkills.value" @change="checkFormValidation('userForm', true, 'interpersonalSkills')"></el-rate>
                </el-form-item>
                <el-form-item class="rating_form_item" label="Problem Solving" prop="problemSolving">
                    <el-rate :ref='el => formsData.userForm.problemSolving.ref = el' v-model="formsData.userForm.problemSolving.value" @change="checkFormValidation('userForm', true, 'problemSolving')"></el-rate>
                </el-form-item>
                <el-form-item class="rating_form_item" label="Organisation" prop="organisation">
                    <el-rate :ref='el => formsData.userForm.organisation.ref = el' v-model="formsData.userForm.organisation.value" @change="checkFormValidation('userForm', true, 'organisation')"></el-rate>
                </el-form-item>
                
                <div class="oot" v-if="userRole === 'pharmacy'">
                    <el-label class="rate-optional">Optional:</el-label>
                    <div v-if="formsData.userForm.addToBlackListLocum.value === false">
                        <el-form-item class="rating_form_item rating_form_item--cust" v-show="showAddPreferedLocumCheckbox()">
                            <el-checkbox
                                    v-model="formsData.userForm.addToPreferredLocum.value"
                                    @change="addToPreferredLocum"
                                    class="mb-2"
                                >
                                Set as preferred locum
                            </el-checkbox>
                        </el-form-item>
                        <el-form-item v-show="showInvitationSentText()">
                            <span class="invite-preferred">Invited to become preferred locum</span>
                        </el-form-item>
                        <el-form-item class="rating_form_item rating_form_item--cust" v-show="showRemovePreferredLocumCheckBox()">
                            <el-checkbox
                                    v-model="formsData.userForm.removePreferredLocum.value"
                                    @change="removeToPreferredLocum"
                                    class="mb-2"
                                >
                                Remove as preferred locum
                            </el-checkbox>
                        </el-form-item>
                    </div>
                    
                    <div v-if="formsData.userForm.addToPreferredLocum.value == false && !checkInvitation" >
                        <el-form-item class="rating_form_item rating_form_item--cust" v-if="!isLocumAlreadyPreferred">
                            <el-checkbox v-show="!formsData.userForm.addToBlackListLocum.value"
                                    class="mb-2"
                                    v-model="formsData.userForm.addToBlackListLocum.value"
                                    @change="addToBlackList"
                                >
                                Block locum
                            </el-checkbox>
                            <el-checkbox
                                    v-show="formsData.userForm.addToBlackListLocum.value"
                                    class="mb-2"
                                    v-model="formsData.userForm.removeBlackListed.value"
                                    @change="removeAsBlackListed"
                                    
                                >
                                Unblock locum
                            </el-checkbox>
                        </el-form-item>
                    </div>
                   
                </div>
           
            </template>
            <el-form-item class="button_submit mb0">
                <el-button class="submit_page w-100" type="blue" @click="submit('userForm')" :disabled="formsData.userForm.disabled">
                    Save
                </el-button>
            </el-form-item>
        </el-form>
    </div>
    </div>
</template>

<script>
    import {
        onMounted,
        ref,
        computed,
        watch
    } from 'vue';

    import {
        ElMessageBox,
    } from '@/components/Vendor/Element';

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonTitle
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'
    import {
        useRouter,
        useRoute
    } from 'vue-router'
    import formHooks from '@/hooks/form/form'
    import formValidate from '@/hooks/form/validate/validate'

    export default {
        components: {
            IonToolbar,
            IonTitle
        },
        setup() {
            const $store = useStore()
            const $router = useRouter()
            const $route = useRoute()
            console.clear();

            const shift = ref($route.params.shift);
            const userData = $store.getters.GET_USER_DATA;
            const userRole = userData.role;
            const userPreferredLocumActivatedList = ref(userData.preferredLocumInvitations);
            const userBlacklist = ref(userData.blacklistedLocum);
          

            const formsDataArray = {
                userForm: {}
            };

            const locumId = shift.value.locum.id;
            let  preferredLocumFound = null;

            if (userRole == 'pharmacy') {
                preferredLocumFound  = shift.value.locum.preferredLocum.find((item) => {
                    if (item.locumId == locumId && item.remove_at == null) {
                        return item;
                    }
                }); 
            }

            const isLocumInBlacklisted = () => {
                return userBlacklist.value.some((item) => item.locumId === locumId);
            };

            const preferredLocumInvitationList = userData.preferredLocumInvitations;
            let invitationFound = null;
            if(userRole == 'pharmacy'){
                invitationFound = preferredLocumInvitationList.find((item) => {
                if (item.locumId == locumId) {
                  return item;
                }
            })
            }
           
            
            const showAddPreferedLocumCheckbox =( ) => {
                if((!preferredLocumFound && !invitationFound) || (!preferredLocumFound &&  invitationFound && invitationFound.acceptedAt)){
                    return true;
                }
                return false;
            }

            const showRemovePreferredLocumCheckBox = () =>
            {
                if(preferredLocumFound){
                    return true;
                }
                return false;
            }


            const showInvitationSentText = () => {
                if(!preferredLocumFound && invitationFound && invitationFound.acceptedAt == null){
                    return true;
                }
                return false;
            }

            if (userRole == 'locum') {
                const dataArray = {
                    rating: {
                        value: null,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'ratingStars', callback, setFormValidation);
                            },
                        }]
                    },
                }

                Object.assign(formsDataArray.userForm, dataArray);
            }

            if (userRole == 'pharmacy') {
                const dataArray = {
                    communication: {
                        value: null,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'ratingStars', callback, setFormValidation);
                            },
                        }]
                    },
                    interpersonalSkills: {
                        value: null,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'ratingStars', callback, setFormValidation);
                            },
                        }]
                    },
                    problemSolving: {
                        value: null,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'ratingStars', callback, setFormValidation);
                            },
                        }]
                    },
                    organisation: {
                        value: null,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'ratingStars', callback, setFormValidation);
                            },
                        }]
                    },
                    addToPreferredLocum: {
                        value: false,
                    },
                    removePreferredLocum: {
                        value: false,
                    },
                    addToBlackListLocum: {
                        value: false,
                    },
                    removeBlackListed:{
                        value:false,
                    }
                }

                Object.assign(formsDataArray.userForm, dataArray);
            }

            const goNext = () => {
                $router.push({
                    name: 'auth_address',
                })
            };

            const checkInvitation = computed(() => {

                   return userPreferredLocumActivatedList.value.some((item) => {
                    if(item.locumId === shift.value.locum.id && item.pharmacyId === shift.value.pharmacy.id){
                        if(item.acceptedAt === null){
                        return true;
                        }else{
                        return false;
                        }
                    }else{
                        return false;
                    }
                    
                    });
            });

            // const isLocumInBlacklisted = computed(() => {
            //     return userBlacklist.value.some((item) => item.locumId === shift.value.locum.id);
            // });

            const isLocumAlreadyPreferred = computed(() => {
                let returnVal = false;
                const preferredLocums = shift.value.locum.preferredLocum;
                preferredLocums.forEach(element => {
                    if(element.locumId === shift.value.locum.id && element.pharmacyId === shift.value.pharmacy.id){
                        returnVal = true;
                    }
                });
                return returnVal;
            });
            const addToPreferredLocum = async(checked) => {
                if (checked) {
                    const confirmed = await showAddToPreferredLocumConfirmation();
                    // Only update the checkbox state if the user confirmed
                    if(confirmed){
                        formsData.userForm.addToPreferredLocum.value = true;
                        formsData.userForm.addToBlackListLocum.value = false;
                        formsData.userForm.removeBlackListed.value = false;
                    }else{
                        formsData.userForm.addToPreferredLocum.value = false;
                    }
                    
                } else {
                    formsData.userForm.addToPreferredLocum.value = false;
                }
            };

            const showAddToPreferredLocumConfirmation = async () => {
                try {
                    await ElMessageBox.confirm('Are you sure you want to add locum as Preferred Locum?', 'Confirmation', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    confirmButtonClass: "el-button--blue",
                    type: 'warning',
                    });
                    return true;
                } catch (error) {
                    if(error === 'cancel'){
                        formsData.userForm.addToPreferredLocum.value = false;
                    }
                    // Handle errors or user closing the dialog
                    return false;
                }
            };

            const removeToPreferredLocum = async(checked) => {
                if (checked) {
                    const confirmed = await showRemoveToPreferredLocumConfirmation();
                    // Only update the checkbox state if the user confirmed
                    if(confirmed){
                        formsData.userForm.removePreferredLocum.value = true;
                    }else{
                        formsData.userForm.removePreferredLocum.value = false;
                    }
                    
                } else {
                    formsData.userForm.removePreferredLocum.value = false;
                }
            };

            const showRemoveToPreferredLocumConfirmation = async () => {
                try {
                    await ElMessageBox.confirm('Are you sure you want to add locum as Preferred Locum?', 'Confirmation', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    confirmButtonClass: "el-button--red",
                    type: 'warning',
                    });
                    return true;
                } catch (error) {
                    if(error === 'cancel'){
                        formsData.userForm.removePreferredLocum.value = false;
                    }
                    // Handle errors or user closing the dialog
                    return false;
                }
            };



            const addToBlackList = async (checked) => {
                if (checked) {
                    const confirmed = await showBlackListConfirmation();
                    // Only update the checkbox state if the user confirmed
                    if(confirmed){
                        formsData.userForm.addToBlackListLocum.value = true;
                        formsData.userForm.removeBlackListed.value = false;
                    }else{
                        formsData.userForm.addToBlackListLocum.value = false;
                    }
                    
                } else {
                    formsData.userForm.addToBlackListLocum.value = false;
                }
            };

            const removeAsBlackListed = async (checked)=>{
                if (checked) {
                    const confirmed = await removeBlackListConfirmation();
                    // Only update the checkbox state if the user confirmed
                    if(confirmed){
                        formsData.userForm.removeBlackListed.value = true;
                        formsData.userForm.addToBlackListLocum.value = false;
                    }else{
                        formsData.userForm.removeBlackListed.value = false;
                    }
                    
                } else {
                    formsData.userForm.removeBlackListed.value = false;
                }
            }

            const showBlackListConfirmation = async () => {
                try {
                    await ElMessageBox.confirm('Are you sure you want to add locum to blacklist?', 'Confirmation', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    confirmButtonClass: "el-button--red",
                    type: 'warning',
                    });
                    return true;
                } catch (error) {
                    if(error === 'cancel'){
                        formsData.userForm.addToBlackListLocum.value = false;
                    }
                    // Handle errors or user closing the dialog
                    return false;
                }
            };
            const removeBlackListConfirmation = async () => {
                try {
                    await ElMessageBox.confirm('Are you sure you want to remove locum from blacklist?', 'Confirmation', {
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    confirmButtonClass: "el-button--red",
                    type: 'warning',
                    });
                    return true;
                } catch (error) {
                    if(error === 'cancel'){
                        formsData.userForm.removeBlackListed.value = false;
                    }
                    // Handle errors or user closing the dialog
                    return false;
                }
            };

             // Watch for changes in the checkbox value and update the state accordingly
            watch(() => formsData.userForm.addToBlackListLocum.value, (newValue) => {
                formsData.userForm.addToBlackListLocum.value = newValue;
                });

            const submit = (formName) => {
                formsRefs[formName].value.validate((valid) => {
                    if (valid) {
                        (async () => {
                            try {
                                let req = null
                                let formValues = getFormValues(formName)
                                let massageText = {
                                    title: 'Thank you for your feedback!',
                                    main: ''
                                };
                                if (userRole == 'locum') {
                                    req = {
                                        shiftId: shift.value.id,
                                        params: {
                                            pharmacy_experience: formValues.rating,
                                        }
                                    }
                                    massageText.main = `Your feedback will help improve the experience for all locums`
                                } else {
                                    req = {
                                        shiftId: shift.value.id,
                                        params: {
                                            locum_communication: formValues.communication,
                                            locum_interpersonal_skills: formValues.interpersonalSkills,
                                            locum_problem_solving: formValues.problemSolving,
                                            locum_organisation: formValues.organisation,
                                            add_to_preferred_locum: formValues.addToPreferredLocum,
                                            add_locum_to_blacklist: formValues.addToBlackListLocum,
                                            remove_locum_from_blacklist: formValues.removeBlackListed,
                                            remove_to_preferred_locum: formValues.removePreferredLocum,
                                        }
                                    }
                                    massageText.main = `This will help us improve the experience for all pharmacies.`
                                }

                                await $store.dispatch('SHIFT_RATING', req);
                           

                                await ElMessageBox.confirm(massageText.main, massageText.title, {
                                    showCancelButton: false,
                                    confirmButtonText: 'Close',
                                    confirmButtonClass: 'el-button--grey',
                                    showClose: false,
                                    type: 'success',
                                    customClass: 'modal_success star',
                                    callback: () => {
                                        $router.push({
                                            name: 'calendar',
                                            params: {
                                                shiftId: shift.value.date,
                                            }
                                        })
                                    }
                                });
                                goNext();
                            } catch (error) {
                                console.log('error submit!!');
                            }
                        })();
                    } else {
                        setFormValidation(formName, false, false);
                        console.log('error submit!!');
                        return false;
                    }
                });
            };


            onMounted(() => {
                setFormRefs();
                checkFormValidation('userForm', false);
                if (userRole == 'pharmacy') {
                formsData.userForm.addToBlackListLocum.value = isLocumInBlacklisted();
                formsData.userForm.removeBlackListed.value = isLocumInBlacklisted() ? ref(false) : ref(true);
                }
            });

            const {
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                getFormValues,
                setFormRefs,
                formsData,
                formsRefs,
            } = formHooks(formsDataArray);

            return {
                shift,
                userData,
                userRole,
                formsData,
                onFormMaskAccept,
                checkFormValidation,
                submit,
                isLocumAlreadyPreferred,
                addToBlackList,
                addToPreferredLocum,
                removeToPreferredLocum,
                userPreferredLocumActivatedList,
                checkInvitation,
                isLocumInBlacklisted,
                showAddPreferedLocumCheckbox,
                showRemovePreferredLocumCheckBox,
                showInvitationSentText,
                userBlacklist,
                removeAsBlackListed
            }
        },
    }
</script>